// Use getComputedStyle for MUI compatibility (MUI doesn't support var() in palettes)
export const primarycolor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#ffa500"